import { LOCALES } from "../constants";

const obj = {
    [LOCALES.SPANISH]: {
        "menu-locations": "Argentina, Colombia, Mexico, Uruguay",
        hello: "Hola",
        "menu-properties": "Propiedades",
        "menu-contact": "Contacto",
        "menu-search": "Buscar",
        "menu-connect-button": "Connectar con MetaMask",
        "home-banner-sales-rep": "Representante oficial Inmobiliario",
        "home-banner-ideal-home": "Tu casa ideal para tu momento ideal",
        "home-banner-help-you":
            "Te ayudaremos a encontrar la casa que estás buscando",
        "home-banner-see-propperties": "Ver Propiedades",
        "search-section-where": "¿Dónde estás buscando?",
        "search-operation-type": "Tipo de operación",
        "search-operation-rental": "Alquiler",
        "search-operation-temporary-rental": "Alquiler Temporal",
        "search-property-type": "Tipo de propiedad",
        "search-property-apartment": "Apartamento",
        "search-property-home": "Casa",
        "search-property-vila": "Villa",
        "search-property-office": "Oficina",
        "more-recent": "Más recientes",
        properties: "Propiedades",
        "product-listing-see-all": "Ver todas",
        "footer-slogan":
            "Te ayudamos a encontrar todo tipo de casas para todo tipo de momentos",
        "footer-project": "Proyecto",
        "footer-properties": "Ver Propiedades",
        "footer-us": "Nosotros",
        "footer-contact": "Contacto",
        "footer-terms": "Términos y condiciones",
        "footer-customer-service": "Servicio al cliente",
        "footer-add-listing": "Agregar propiedad",
        "home-page": "Inicio",
        "page-nosotros-header": "Nosotros",
        "page-404": "Error 404",
        "page-myaccount-header": "Mi cuenta",
        "myaccount-profile": "Perfil",
        "myaccount-register-account": "Registrarse",
        "myaccount-personal-data": "Datos personales",
        "myaccount-my-properties": "Mis Propiedades NFT",
        "myaccount-property-bookings": "Reservas de propiedades",
        "myaccount-add-properties": "Agregar Propiedad",
        "myaccount-rewards": "Recompensas",
        "myaccount-agent-label": "Agente inmobiliario",
        "myaccount-profile-edit": "Editar tu perfil",
        "myaccount-profile-name": "Nombre",
        "myaccount-profile-lastname": "Apellido",
        "myaccount-profile-country": "Pais",
        "myaccount-profile-save-changes": "Guardar cambios",
        "myaccount-my-props-title": "Mis Propiedades",
        "myaccount-my-props-date": "Fecha de ingreso",
        "myaccount-my-props-list-property": "Listar Propiedad",
        "myaccount-history-property": "Propiedad",
        "myaccount-history-date": "Fecha ingreso",
        "myaccount-history-actions": "Acciones",
        "myaccount-history-delete": "Eliminar",
        "myaccount-add-property-page-title": "Agregar nueva propiedad",
        "myaccount-add-property-details-title": "Detalles de la propiedad",
        "myaccount-add-property-title-field": "Titulo de la propiedad*",
        "myaccount-add-property-description-field": "Descripcion*",
        "myaccount-add-property-price-field": "Precio",
        "myaccount-add-property-category-field": "Categoria",
        "myaccount-add-property-pictures-field": "Fotos",
        "myaccount-add-property-pictures-comments-1":
            "* Ingrese al menos una imagen superior a 500x500px.",
        "myaccount-add-property-pictures-comments-2":
            "* Pueden ingresarse archivos PDF.",
        "myaccount-add-property-pictures-comments-3":
            "* Las imagenes pueden demorar en procesarse.",
        "myaccount-add-property-location-title": "Ubicación",
        "myaccount-add-property-address-field": "Direccion*",
        "myaccount-add-property-country-field": "País",
        "myaccount-add-property-city-field": "Ciudad",
        "myaccount-add-property-state-field":
            "Provincia* / Estado / Departamento",
        "myaccount-add-property-lat-field": "Latitud (Google Maps)",
        "myaccount-add-property-lon-field": "Longitud (Google Maps)",
        "myaccount-add-property-load-automatically":
            "Cargar ubicación automaticamente",
        "myaccount-add-property-rooms-field": "Ambientes*",
        "myaccount-add-property-size-field": "Tamaño (m2)",
        "myaccount-add-property-bathrooms-field": "Baños",
        "myaccount-add-property-garages-field": "Garages",
        "myaccount-add-property-basement-field": "Sotano",
        "myaccount-add-property-balcony-field": "Terraza",
        "myaccount-add-property-save-button": "Guardar propiedad",
        "myaccount-add-property-select": "Seleccione la categoria",
        "myaccount-rewards-send-button": "Enviar",
        "myaccount-rewards-receive-button": "Recibir",
        "myaccount-rewards-rewards-history": "Historial de rewards",
        "myaccount-rewards-badges": "Emblemas",
        "page-properties-header": "Propiedades",
        "properties-sort-by": "Ordenar por:",
        "properties-price": "Precio",
        "properties-more-recent": "Más Recientes",
        "properties-popular": "Popular",
        "properties-filter": "Filtrar...",
        "properties-helper-accept-location":
            "Para cargar las propiedades cercanas a tu ubicación, debes aceptar compartir tu ubicación en la ventana emergente que verás al ingresar a esta página ",
        "properties-helper-connected-network":
            "Aún no hay propiedades, chequea que estes conectado a la red correcta en metamask",
        "properties-rent": "Alquiler",
        "properties-rooms": "Habitaciones",
        "properties-month": "Mes",
        "properties-information-title": "Información",
        "properties-type-title": "Tipo de propiedad",
        "properties-house": "Casa",
        "properties-apartment": "Apartamento",
        "properties-office": "Oficina",
        "properties-duplex": "Duplex",
        "properties-industrial": "Industrial",
        "properties-filter-price": "Filtrar por precio",
        "properties-categories": "Categorias",
        "property-details-header": "Descripción de la propiedad",
        "property-details-featured-badge": "Destacado",
        "property-details-rent-badge": "Alquiler",
        "property-details-comments": "Comentarios",
        "property-details-rent-now": "Alquilar ahora",
        "property-details-rooms": "Habitaciones",
        "property-details-description": "Descripción",
        "property-details-badges-agent": "Emblemas del agente",
        "property-details-badges-property": "Medallas de la propiedad",
        "property-details-no-badges": "Esta propiedad no tiene medallas aún",
        "property-details-real-state-agent": "Agente inmobiliario",
        "property-details-seller-description":
            "Vendedora hace 15 años en la plataforma Bonvo.",
        "property-details-location": "Ubicación",
        "property-details-reviews": "Reseñas",
        "page-contact-header": "Contacto",
        "page-contact-contact-email": "Contacto",
        "page-contact-phone": "Telefono",
        "page-contact-contact-us": "Contactanos",
        "page-contact-type": "Tipo de consulta",
        "page-contact-home-rental": "Alquiler de casa",
        "page-contact-property-management": "Administración de propiedades",
        "page-contact-resolve-conflict": "Resolver conflicto",
        "page-contact-others": "Otros",
        "page-contact-store-data": "Almacenar mis datos para la próxima vez",
        "page-contact-send-question": "Enviar consulta",
        "page-contact-insert-name": "Ingrese su nombre",
        "page-contact-insert-email": "Ingrese su email",
        "page-contact-insert-phone": "Ingrese su teléfono",
        "page-contact-write-message": "Escriba su mensaje",
    },
};

export default obj;
